import React, { Component } from 'react';
import { Field, reduxForm, formValueSelector, FormSection, SubmissionError, reset } from 'redux-form';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import agent from '../../agent'
import renderDatePicker from '../Datepicker';
import Countries from '../../data/countries';
import CountryStates from '../../data/states';
import CheckBox from '../CheckBox'
import Terms from '../Terms';
import SelectComponent from '../ui/SelectComponent'

const renderFields = ({ input, label, type, id, name, className, meta: { touched, error } }) => {
  return (    
    <div className="custom-checkbox">
      <input {...input} type={type} name={name} className={className} id={id} />
      <label htmlFor={id}>{label}</label>
      { (touched && error) && <p className="form-error is-visible" id="uuid">{error}</p> }
    </div>
  )
}

const renderError = ({ meta: { touched, error } }) => 
  touched && error ? <p className="form-error is-visible" id="uuid">{error}</p> : false 

const validate = {
  ageCategory: value => value ? undefined : 'Please select Age category',
  country: value => value ? undefined : 'Please select your Country',
  termsOfUse: value => value ? undefined : 'You need to accept the terms to continue'
}

class General extends Component {  
  state = { 
    country: '',
    countries: Countries,
    age_from: 0,
    age_to: 0,
    ageCategory : ''
  }

  onChangeCountry = (value, countryCode) => {
    this.setState({
      country: countryCode,
    })
  }

  onChangeAgeCategory = (value) => {
    this.setState({
      ageCategory: value,
      age_from: value == 'adult' ? 18 : 0,
      age_to: value == 'adult' ? 99 : 19
    })
  }

  getCountries = () => {
    return this.state.countries.map(item => { 
      return { value: item.code, label: item.name }; 
    })
  }

  submit = (values, dispatch, props) => {
    console.log('submit-general.js', values, dispatch, props)
    return props.onSubmit(props.handleSubmit);
  }

  render() {
    const { handleSubmit, submitting, pristine, error, labels } = this.props
    console.log('render-general.js', this.state.age_from, this.state.age_to)

    return (
      <form onSubmit={ handleSubmit(this.submit) } className="registartion-general-form" id="reg-general-form" >
        <FormSection name="artist">
        <section className="section gray-bg">
          <div className="grid-x align-center">
          <div className="small-12 medium-10 large-8 cell">
            
            <div className="text-center white-text">
              <p>{labels.country_label}</p>
            </div>

            <div className="row">
              <div className="small-12 medium-8 medium-centered column">
                <Field 
                    name="country" 
                    placeholder="Please select country"
                    component={SelectComponent} 
                    validate={[validate.country]}
                    onChange={this.onChangeCountry}
                    options={this.state.countries}
                    value={this.state.country}
                    valueKey="code" 
                    labelKey="name"
                />
              </div>
            </div>

            <div className="row text-center">
              <div className="small-12 column age-confirmation">

                <div className="custom-checkbox">
                  <Field
                    className="styled-checkbox"
                    name="ageCategory"
                    id="is-adult"
                    value="adult"
                    onChange={event => this.onChangeAgeCategory(event.target.value)}
                    component="input"
                    type="radio"
                  />
                  <label htmlFor="is-adult">{labels.adult}</label>
                </div>

                <div className="custom-checkbox">
                  <Field
                    className="styled-checkbox"
                    name="ageCategory"
                    id="is-child"
                    value="child"
                    onChange={event => this.onChangeAgeCategory(event.target.value)}
                    component="input"
                    type="radio"
                  />
                  <label htmlFor="is-child">{labels.minor}</label>
                </div>

                <Field name="ageCategory" validate={[validate.ageCategory]} component={renderError} />
                <Field name="age_from" value={this.state.age_from} className="hide" component="input" />
                <Field name="age_to" value={this.state.age_to} className="hide" component="input" />

              </div>
            </div>

            <div className="row white-text">
              <div className="small-12 medium-10 medium-centered column">
               <div className="terms-condition">
                <Terms />
               </div>
              </div>
            </div>

            <div className="row white-text text-center">
              <div className="small-12 medium-8 medium-centered column">
                
                  <Field
                    className="styled-checkbox"
                    name="termsOfUse"
                    validate={[validate.termsOfUse]}
                    id="term_use"
                    component={renderFields}
                    type="checkbox"
                    label={labels.agreed}
                  />
                
              </div>
            </div>
        
          </div>
          </div>
        </section>

        <section className="section">
          <div className="grid-x align-center">
            <div className="small-12 cell text-center">
              <button className="button primary" 
                type="submit" 
                disabled={pristine || submitting}>
                  {submitting ? 'Loading...' : 'Continue' }
              </button>
            </div>
          </div>
        </section>

       </FormSection>

      </form>
    )
  }
}

export default reduxForm({
  form: 'artistRegistrationWizard', // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(General)






// WEBPACK FOOTER //
// ./src/components/register/General.js